import { Checkbox, Col, Row, Divider } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { isRoleSponsor } from "../orphans/utils";
interface InfoProps {
  infoArray: any;
  role: string
}
const SponsorInfoContent = ({ infoArray,role }: InfoProps) => {
  const { t } = useTranslation();
  return (
    <>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>الإسم</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{infoArray?.name}</span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p>الإسم بالإنجليزي </p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <span>{infoArray?.eng_name}</span>
        </Col>
      </Row>
      {isRoleSponsor(role) && (
        <Row
          justify={"space-between"}
          className="takaful--content-profile-box1"
        >
          <Col
            xxl={5}
            xl={5}
            lg={5}
            md={5}
            sm={12}
            xs={12}
            className="takaful--content-profile-col"
          >
            <p>رقم الكافل</p>
          </Col>
          <Col
            xxl={6}
            xl={6}
            lg={6}
            md={6}
            sm={12}
            xs={12}
            className="takaful--content-profile-col"
          >
            <span>{infoArray?.sponsor_number}</span>
          </Col>

          <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

          <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
            <p>تاريخ طلب الكفالة</p>
          </Col>
          <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
            <span>
              {infoArray?.sponsorship_request_date &&
                new Date(
                  infoArray.sponsorship_request_date
                ).toLocaleDateString()}
            </span>
          </Col>
        </Row>
      )}
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>الجنس</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{t(`gender.${infoArray?.gender}`)}</span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p>نوع الهوية</p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <span>{infoArray?.identification_type_id}</span>
        </Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>رقم الهوية</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{infoArray?.identification_number}</span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p>تاريخها </p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <span>
            {infoArray?.identification_date &&
              new Date(infoArray.identification_date).toLocaleDateString()}
          </span>
        </Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>الهاتف</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{infoArray?.mobile}</span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p>البريد الإلكتروني</p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <span>{infoArray?.email}</span>
        </Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>العنوان الوطني</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{infoArray?.street}</span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p>الجنسية</p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <span>{infoArray?.nationality_id}</span>
        </Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>طرق التواصل</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>
            {infoArray?.contact_method_ids
              ?.map((method: any) => method?.name)
              .join(", ")}
          </span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}></Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}></Col>
      </Row>

      {isRoleSponsor(role) && (
        <Row
          justify={"space-between"}
          className="takaful--content-profile-box1"
        >
          <Col
            xxl={5}
            xl={5}
            lg={5}
            md={5}
            sm={12}
            xs={12}
            className="takaful--content-profile-col"
          >
            <p>هل ترغب الحضور في برنامج لقاء الكفلاء بالأيتام</p>
          </Col>
          <Col
            xxl={6}
            xl={6}
            lg={6}
            md={6}
            sm={12}
            xs={12}
            className="takaful--content-profile-col"
            style={{ paddingTop: "1rem" }}
          >
            <Checkbox
              checked={infoArray?.want_attending_orphan_sponsor_meeting}
              className="takaful--check-style"
            ></Checkbox>
          </Col>

          <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

          <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
            <p>السماح بإرسال رسائل تذكير بالسداد</p>
          </Col>
          <Col
            xxl={6}
            xl={6}
            lg={6}
            md={6}
            sm={12}
            xs={12}
            style={{ paddingTop: "1rem" }}
          >
            <Checkbox
              checked={infoArray?.allow_send_reminder_sms}
              className="takaful--check-style"
            ></Checkbox>
          </Col>
        </Row>
      )}
      <Divider className="takaful--service-section-divider" />

      <Row className="takaful--content-profile-box1">
        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
          <div className="takaful--content-profile-title">
            <h1>الحساب البنكي</h1>
          </div>
        </Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>إسم صاحب الحساب</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{infoArray?.acc_holder_name}</span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p>رقم الحساب</p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <span>{infoArray?.acc_number}</span>
        </Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>البنك</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          {Array.isArray(infoArray?.bank_id) &&
            infoArray?.bank_id.length > 1 && (
              <span>{infoArray?.bank_id[1]}</span>
            )}
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}></Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}></Col>
      </Row>
    </>
  );
};

export default SponsorInfoContent;
